import type { GlobalConstants } from 'env'
import { inject } from 'vue'

export function useGlobals(): GlobalConstants {
  const globals = inject<GlobalConstants>('globalConstants')

  if (!globals) {
    throw new Error('Global constants not provided')
  }

  return globals
}
